import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=45d32cf8&scoped=true&"
import script from "./SendSms.vue?vue&type=script&lang=js&"
export * from "./SendSms.vue?vue&type=script&lang=js&"
import style0 from "./SendSms.vue?vue&type=style&index=0&id=45d32cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d32cf8",
  null
  
)

export default component.exports